export function LogicBoxViewConstructor(services, callbacks, context, siteTypeConfig) {
  
  let joint = services.joint;

  return joint.shapes.html.AbstractBoxElementView.extend({

    template: [
      '<div class="html-element logic-box">',
      '  <div class="question-text-content-container">',
      '    <div class="logic-box-text">',
      '      <div class="logic-expression">',
               services.$translate.instant('parameters/quick_replies/details/graph/if_then_else_expression') + ': ',
      '        <span class="logic-expression-value"></span>',
      '      </div>',
      '    </div>',
      '    <div class="item-edit-container"><span class="glyphicon glyphicon-pencil item-edit"></span></div>',
      '  </div>',
      '</div>'
    ].join(''),

    hasExpression: null,
    titleOfEditionPopin: null,

    initialize: function() {
      joint.shapes.html.AbstractBoxElementView.prototype.initialize.apply(this, arguments);

      // this.$box is initialized by the abstract superclass
      this.$box.find('.item-edit').on('click', () => this.editLogicBox());

      switch (this.model.get('type')) {
        case 'html.IfThenElseBox':
          this.titleOfEditionPopin = services.$translate.instant('parameters/quick_replies/details/graph/if_then_else_box_title_in_panel');
          this.hasExpression = true;
          break;
        case 'html.BHBNHBox':
          this.titleOfEditionPopin = services.$translate.instant('parameters/quick_replies/details/graph/bh_nbh_box_title_in_panel');
          this.hasExpression = false;
          break;
      }
      if (!this.hasExpression) {
        this.$box.find('.question-text-content-container').addClass('hide');
      }
    },

    resizeBox: function() {
      if (services.JointjsOptimisationsFactory.logCallsToResize()) {
        console.warn('LogicBoxView - resizeBox()');
      }
      let box = this.model;
      let embeddedCells = box.getEmbeddedCells();
      let paddingTop = this.$box.find('.logic-box-text').outerHeight();

      //Reposition and resize every item
      let ypos = paddingTop ;
      for (let child of embeddedCells) {
        let childView = this.paper.findViewByModel(child);
        child.position(0, ypos, {parentRelative: true});
        let childHeight = childView.$box.outerHeight();
        child.resize(box.attributes.size.width, childHeight);
        ypos += childHeight;
      }

      box.fitEmbeds({padding: {top: paddingTop, right: 0, bottom: 0, left: 0}});
      callbacks.resizePaper();
    },

    updateBox: function() {
      if(this.paper) {
        this.$box.find('.logic-expression-value').text(this.model.get('expression'));
      }
      joint.shapes.html.AbstractBoxElementView.prototype.updateBox.apply(this, arguments);
    },

    /**
     * Event handler that shows a modal
     * for editing the input and output variable names
     */
    editLogicBox: function() {
      let modalInstance = services.$uibModal.open({
        animation: true,
        template:  require('./editLogicBox.modal.html'),
        controller: 'editLogicBoxController',
          resolve: {
            controllerParams: {
              expression: this.model.get('expression'),
              title: this.titleOfEditionPopin,
            }
          }
      });
      // Hook callback that will update the model and save the updated graph
      modalInstance.result.then(result => {
        this.model.set('expression', result.expression);
        this.resizeBox();
        callbacks.updateSerializedGraph(this.model.graph);
      });
    },

  });
}